import { render, staticRenderFns } from "./amazonproducts.vue?vue&type=template&id=b020ecba"
import script from "./amazonproducts.vue?vue&type=script&lang=js"
export * from "./amazonproducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports